//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class LibraryLendingUpdateItem extends ItemBase {
    ID: string | null = null;
    DueDate: string | null = null;
    LoanedByTeacherID: string | null = null;
    LoanedOn: string | null = null;
    ItemName: string | null = null;
    ItemType: string | null = null;
    PrivateNote: string | null = null;
    PublicNote: string | null = null;
    Publisher: string | null = null;
    SerialNumber: string | null = null;
    ShareWithSchool: boolean = false;
    StudentID: string | null = null;

    constructor(initializer?: Partial<LibraryLendingUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LibraryLendingUpdateItem";
}
